var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 57v2a7 7 0 0 0 7 7h56a7 7 0 0 0 7-7V27a7 7 0 0 0-7-7h-3v30a7 7 0 0 1-7 7H26Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 52a1 1 0 0 1 1-.8l15.8.7c1 0 1.4 1.3.5 1.8L8.2 65.2a1 1 0 0 1-1.5-1.1l3.6-12.2ZM87.1 63.6c.5 0 1 .3 1 .8l2 9.4a1 1 0 0 1-1.5 1l-14.4-8.6a1 1 0 0 1 .5-1.9l12.4-.7Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0A10 10 0 0 0 0 10v33a10 10 0 0 0 10 10h61a10 10 0 0 0 10-10V10A10 10 0 0 0 71 0H10Zm11 30a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm25-5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm15 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChatIcon);
export default __webpack_public_path__ + "static/media/menu-chat-icon.38bd919b6fb13507313fa2c34e006aa8.svg";
export { ForwardRef as ReactComponent };